import React from "react";

import {Icon} from '@types';

const CircleCheck: Icon = ({}) => (
  <svg
    width="19"
    height="17"
    viewBox="0 0 19 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.19995 6.90968L8.18745 11.4L17.8 1"
      stroke="black"
    />
    <path
      d="M15 8.80005C15 10.3289 14.4995 11.8156 13.575 13.0332C12.6504 14.2508 11.3527 15.1322 9.88005 15.5429C8.40741 15.9535 6.84083 15.8707 5.41968 15.3071C3.99852 14.7436 2.80093 13.7303 2.00989 12.422C1.21884 11.1137 0.877848 9.58249 1.039 8.0622C1.20014 6.5419 1.85458 5.11616 2.90231 4.00281C3.95003 2.88946 5.33344 2.14973 6.84116 1.89664C8.34888 1.64354 9.898 1.89101 11.2518 2.60122"
      stroke="black"
    />
  </svg>
);

export default CircleCheck;
